export default __webpack_public_path__ + "static/media/devu_logo.9b8c7c9e.png";